// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__70eu9","footer":"ModalError_footer__23N8Z"};